import { render, staticRenderFns } from "./orderReviewList.vue?vue&type=template&id=68a69a80&"
import script from "./orderReviewList.vue?vue&type=script&lang=js&"
export * from "./orderReviewList.vue?vue&type=script&lang=js&"
import style0 from "./orderReviewList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports